import React, { useState, useEffect, useRef } from 'react';
import MySelect from '../MySelect/MySelect';
import LoadingButton from '../LoadingButton/LoadingButton';
import './emailSelector.css';

const EmailSelector = ({
  fetchFunction,
  code,
  onClose,
  onConfirm,
  onCancel,
  sendFunction = null,
}) => {
  const [clientEmails, setClientEmails] = useState(['']);
  const [defaultEmails, setDefaultEmails] = useState([]);
  const [emailList, setEmailList] = useState([]);
  const [emailNumber, setEmailNumber] = useState(1);
  const [errorMessage, setErrorMessage] = useState('');
  const hasInitialized = useRef(false);

  useEffect(() => {
    const fetchData = async normalizedCodes => {
      try {
        let new_client_emails = [];
        let collected_default_emails = [];

        for (const clientCode of normalizedCodes) {
          const fetchedData = await fetchFunction(clientCode);

          if (
            collected_default_emails.length === 0 &&
            fetchedData['default_emails'] &&
            Array.isArray(fetchedData['default_emails'])
          ) {
            collected_default_emails = fetchedData['default_emails'];
          }

          // Ajouter les emails du carnet avec vérification de duplication
          if (fetchedData['email_book'] !== '') {
            const client_email_book = fetchedData['email_book'].split(',');
            client_email_book.forEach(email => {
              const trimmedEmail = email.trim();
              if (trimmedEmail && !new_client_emails.includes(trimmedEmail)) {
                new_client_emails.push(trimmedEmail);
              }
            });
          }

          // Ajouter establishment_email s'il n'existe pas déjà
          const establishmentEmail = fetchedData['establishment_email']?.trim();
          if (establishmentEmail && !new_client_emails.includes(establishmentEmail)) {
            new_client_emails.push(establishmentEmail);
          }

          // Ajouter pickup_email s'il n'existe pas déjà
          const pickupEmail = fetchedData['pickup_email']?.trim();
          if (pickupEmail && !new_client_emails.includes(pickupEmail)) {
            new_client_emails.push(pickupEmail);
          }
        }

        setClientEmails(new_client_emails);
        setDefaultEmails(collected_default_emails);
      } catch (error) {
        console.error('Erreur lors de la récupération des emails client:', error);
      }
    };

    const normalizedCodes = Array.isArray(code) ? code : [code];
    fetchData(normalizedCodes);
  }, [code, fetchFunction, sendFunction]);

  useEffect(() => {
    if (clientEmails.length > 0 && clientEmails[0] !== '' && !hasInitialized.current) {
      const validDefaultEmails =
        defaultEmails.length > 0 ? defaultEmails.filter(email => clientEmails.includes(email)) : [];

      if (validDefaultEmails.length > 0) {
        setEmailList(validDefaultEmails);
        setEmailNumber(validDefaultEmails.length);
      } else {
        setEmailList([clientEmails[0]]);
        setEmailNumber(1);
      }
      hasInitialized.current = true;
    }
  }, [clientEmails, defaultEmails]);

  const onTriggerConfirm = async () => {
    const filteredEmailList = emailList.filter(element => element !== '');

    if (filteredEmailList.length === 0) {
      setErrorMessage('Veuillez sélectionner au moins un email');
      return;
    }

    setErrorMessage('');
    if (sendFunction === null) {
      await onConfirm(filteredEmailList);
    } else {
      await onConfirm(filteredEmailList, sendFunction);
    }
  };

  const handleSelectChange = (selectedOption, index) => {
    const newEmailList = [...emailList];
    newEmailList[index] = selectedOption ? selectedOption.value : '';
    setEmailList(newEmailList);
    setErrorMessage('');
  };

  const handleAddSelect = () => {
    setEmailNumber(emailNumber + 1);
    setEmailList([...emailList, '']);
  };

  const getAvailableEmailsForIndex = index => {
    const selectedEmails = emailList.filter((email, i) => i !== index && email !== '');
    return clientEmails.filter(email => !selectedEmails.includes(email));
  };

  return (
    <div className="email-selector-overlay">
      <div className="email-selector">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>
        <p>Choix de/des emails d'envoi</p>
        <div className="email-selects">
          {Array.from({ length: emailNumber }).map((_, index) => (
            <MySelect
              key={index}
              values={getAvailableEmailsForIndex(index)}
              isCreatable={true}
              value={emailList[index] ? { value: emailList[index], label: emailList[index] } : null}
              onChange={selectedOption => handleSelectChange(selectedOption, index)}
              validationType="email"
            />
          ))}
        </div>
        <div className="addbutton-container">
          <button type="button" onClick={handleAddSelect}>
            +
          </button>
        </div>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <div className="email-selector-buttons">
          <LoadingButton onClick={onTriggerConfirm}>Valider</LoadingButton>
          <button onClick={onCancel}>Annuler</button>
        </div>
      </div>
    </div>
  );
};

export default EmailSelector;
